import React, { useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import Menu from './Menu';
import Shipments from './Shipments';
import Notices from './Notices';
import Validate from './Validate';
import Travel from './Travel';
import Branch from './Branch';
import Invoices from './Invoices';
import AccountStatus from './AccountStatus';
import Lineage from './Lineage';
import ChangePassword from './ChangePassword';
import Certificates from './Certificates';
import Calendar from './Calendar';
import Award from './Award';
import Attentions from './Attentions';
import ContractUS from './ContractUS';
import BusinessSimulator from './BusinessSimulator';
import Documents from './Documents';
import ContactMX from './ContractMX';
import ConsultData from './ConsultData';
import ConsultDataUS from './ConsultDataUS';
import Petition from './Petition';
import CatalogsUS from './CatalogsUS';
import CatalogsMX from './CatalogsMX';
import Wheel from './Wheel';
import MenuContracts from './MenuContracts';
import TerraVoucher from './TerraVoucher';
import MyOrders from './MyOrders';
import DetailMyOrders from './MyOrders/DetailMyOrder';
import Legales from '../Legales';
import TaxData from './TaxData';
import MyDigitalOrders from './../MyDigitalOrders';
import DigitalCatalog from './DigitalCatalog';
import DigitalMagazine from './DigitalMagazine';
import TerrapointsDetail from './TerrapointsDetail';
import Reshipments from './Reshipments';

import getCookie from '../Queries/getCookie';

// Styles
import styles from './index.module.sass';
import Warehouse from '../Warehouse';

const Consultancy = (props) => {
  const { t } = useTranslation('personalDataUS');
  const [copyIcon, setCopyIcon] = useState('content_copy');
  const {
    device,
    match,
    history,
    webservice,
    adminWebservice,
    getCookie,
    setSessionMessage,
    pathname,
  } = props;
  const { screenSize } = device;

  const isBrochure = pathname.includes('brochure');

  function copyBrochureLink() {
    navigator.clipboard
      .writeText(digitalBrochureLink)
      .then(() => {
        setCopyIcon('done');
        setTimeout(() => {
          setCopyIcon('content_copy');
        }, '3000');
      })
      .catch((err) => {
        console.error('Error in copying text: ', err);
      });
  }

  const digitalBrochureLink = `${process.env.REACT_APP_MY_DIGITAL_BROCHURE}/${getCookie(
    'usuarioOk',
  )}`;

  return (
    <div id={styles.Consultancy} className={styles[screenSize]}>
      <div className={styles.consultancyHeader}>
        {(isBrochure && (
          <div className={styles.myDigitalCatalog}>
            <span className={styles.myDigitalText}>{t('mayDigitalText')}: </span>
            <a
              href={digitalBrochureLink}
              className={styles.myDigitalLink}
              target='_blank'
              rel='noreferrer'>
              {digitalBrochureLink}
            </a>
            <div className={styles.copyIcon}>
              <i className={`material-icons ${styles.icon}`} onClick={copyBrochureLink}>
                {copyIcon}
              </i>
            </div>
            {copyIcon === 'done' && <div className={styles.copiedText}>{t('linkCopied')}</div>}
          </div>
        )) || (
          <div className={styles.consultancyName}>{`${getCookie('usuario')}: ${getCookie(
            'kitName',
          )}`}</div>
        )}
      </div>

      <div className={styles.consultancyContainer}>
        <Switch>
          <Route
            exact
            path={`${match.path}/`}
            render={(props) => <Redirect to={`${match.path}/home`} />}
          />
          <Route
            path={`${match.path}/legal`}
            render={(props) => {
              return <Legales {...props} device={device} history={history} />;
            }}
          />
          <Route
            path={`${match.path}/panel`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Menu
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    match={match}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/shipments`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Shipments
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    adminWebservice={adminWebservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/validate`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Validate
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/travel`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Travel
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/nationaltravel`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Travel
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/notices`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Notices
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/branch`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Branch
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/invoices`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Invoices
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/accountstatus`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <AccountStatus
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/lineagestatus`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Lineage
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/petition`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Petition
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/changePassword`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <ChangePassword
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/certificates`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Certificates
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/calendar`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Calendar
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/awards`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Award
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/attentions`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Attentions
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/contract`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <MenuContracts
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/contractsMX`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <ContactMX
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/contractUS`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <ContractUS
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                    typecontract='prefillus'
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/simulator`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <BusinessSimulator
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/documents`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Documents
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/consultData`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <ConsultData
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/consultDataUS`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <ConsultDataUS
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/catalogsus`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <CatalogsUS
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/catalogsmx`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <CatalogsMX
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/wheel`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Wheel
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />

          <Route
            path={`${match.path}/terravoucher`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <TerraVoucher
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/warehouse`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Warehouse
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/myOrders`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <MyOrders
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/reshipments`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <Reshipments
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/taxData`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <TaxData
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
          <Route
            path={`${match.path}/MyDigitalOrders`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <MyDigitalOrders
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />

          <Route
            exact
            path={`${match.path}/DetailMyOrders/:pedido`}
            render={(props) => {
              return (
                <DetailMyOrders
                  {...props}
                  device={device}
                  history={history}
                  webservice={webservice}
                  getCookie={getCookie}
                  match={match}
                  setSessionMessage={setSessionMessage}
                />
              );
            }}
          />
          <Route
            path={`${match.path}/brochure`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && <DigitalCatalog {...props} device={device} />) || (
                  <Redirect to={`${match.path}/`} />
                )
              );
            }}
          />
          <Route
            path={`${match.path}/magazine`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && <DigitalMagazine {...props} device={device} />) || (
                  <Redirect to={`${match.path}/`} />
                )
              );
            }}
          />
          <Route
            path={`${match.path}/terrapointsDetail`}
            render={(props) => {
              return (
                (getCookie('usuarioOk') && (
                  <TerrapointsDetail
                    {...props}
                    device={device}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    setSessionMessage={setSessionMessage}
                  />
                )) || <Redirect to={`${match.path}/`} />
              );
            }}
          />
        </Switch>
      </div>
    </div>
  );
};

export default Consultancy;
